__turbopack_context__.v({
  "is-active": "index-module-scss-module___cxC8a__is-active",
  "vertical-menu": "index-module-scss-module___cxC8a__vertical-menu",
  "vertical-menu__arrow": "index-module-scss-module___cxC8a__vertical-menu__arrow",
});
